import {
  ApplicationInsights,
  IExceptionTelemetry,
  ITelemetryPlugin,
} from '@microsoft/applicationinsights-web'
import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import { APP_INSIGHTS_KEY } from '../constants'

export const reactPlugin = new ReactPlugin()
let appInsights: ApplicationInsights
if (APP_INSIGHTS_KEY) {
  console.log('Use App Insights')
  appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: process.env.REACT_APP_APPLICATION_INSIGHTS_KEY,
      extensions: [reactPlugin as unknown as ITelemetryPlugin],
    },
  })
  appInsights.loadAppInsights()
  appInsights.trackTrace({
    message: 'Client connected: ' + window.location.href,
  })
}

export function trackException(exception: IExceptionTelemetry) {
  if (!appInsights) {
    return
  }

  console.log('tracking exception')
  return appInsights.trackException(exception)
}
